import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {Action, select, Store} from '@ngrx/store';
import {Observable} from 'rxjs/Observable';
import {filter, flatMap, map, withLatestFrom} from 'rxjs/operators';
import {
    BILD_ID_ENTFERNEN,
    BILD_ID_HINZUFUEGEN, BildIdEntfernenAction,
    BildIdHinzufuegenAction,
    EINGANG_NEU_LADEN,
    EingangNeuLadenAction,
    INCIDENT_AUSGEWAEHLT,
    IncidentAusgewaehltAction, LOAD_PAGE_DATA,
    PageStateResetAction,
    POST_INCIDENT_ABGEBEN_UI,
    POST_INCIDENT_MELDUNG_SETZEN_UI,
    POST_INCIDENT_NICHT_OK_SETZEN_UI,
    POST_INCIDENT_OK_SETZEN_UI,
    POST_INCIDENT_UEBERNEHMEN_UI,
    PostIncidentAbgebenUiAction,
    PostIncidentMeldungSetzenUiAction,
    PostIncidentNichtOkSetzenUiAction,
    PostIncidentOkSetzenUiAction,
    PostIncidentUebernehmenUiAction
} from './meine-aufgaben.actions.ui';
import {GetIncidentDetailAction, GetMeineIncidents2Action, PostIncidentAbgebenAction, PostIncidentBildEntfernenAction, PostIncidentBildHinzufuegenAction, PostIncidentMeldungAktualisierenAction, PostIncidentMeldungErfassenAction, PostIncidentNichtOkErfassenAction, PostIncidentOkErfassenAction, PostIncidentUebernehmenAction} from '../../../client-ngrx/incidents';
import {UuidService} from '@orga-app/providers/uuid.service';
import {getIncidentDetail, getSelectedMeldung, getSelectedVeranstaltungsIds} from './meine-aufgaben.selectors';
import {IncidentBildRequest, IncidentMeldungRequest, IncidentRequest} from '../../../clients/incidents';

@Injectable()
export class MeineAufgabenPageUiEffects {

    @Effect()
    datenLaden$: Observable<Action> = this.actions$.pipe(
        ofType(LOAD_PAGE_DATA),
        withLatestFrom(this.store$.pipe(select(getSelectedVeranstaltungsIds))),
        filter(([x, ids]: [PageStateResetAction, Array<string>]) => (ids !== null && ids !== undefined && ids.length > 0)),
        flatMap(([x, ids]: [PageStateResetAction, Array<string>]) =>
            [new GetMeineIncidents2Action(ids)]
        )
    );

    @Effect()
    eingangNeuLaden$: Observable<Action> = this.actions$.pipe(
        ofType<EingangNeuLadenAction>(EINGANG_NEU_LADEN),
        withLatestFrom(this.store$.pipe(select(getSelectedVeranstaltungsIds))),
        filter(([x, ids]) => (ids !== null && ids !== undefined && ids.length > 0)),
        map(([x, ids]) =>
            new GetMeineIncidents2Action(ids)
        )
    );

   @Effect()
   setzeSelected$: Observable<Action> = this.actions$.pipe(
       ofType<IncidentAusgewaehltAction>(INCIDENT_AUSGEWAEHLT),
       filter((x) => x.payload !== null),
       map(x =>
            new GetIncidentDetailAction(x.payload.incident_id)
       )
   );


   @Effect()
    meldungErfassen$: Observable<Action> = this.actions$.pipe(
        ofType<PostIncidentMeldungSetzenUiAction>(POST_INCIDENT_MELDUNG_SETZEN_UI),
        withLatestFrom(this.store$.pipe(select(getIncidentDetail)),
            this.store$.pipe(select(getSelectedMeldung))),
        filter(([x, detail, meldung]) => detail !== null && meldung === null),
        map(([x, detail, meldung]) => {
                const request: IncidentMeldungRequest = {
                    incident_id: detail.incident_id,
                    meldung_id: this.uuid.generateUUID(),
                    text: x.payload,
                };
                return new PostIncidentMeldungErfassenAction(request);
            }
        )
    );

    @Effect()
    meldungAendern$: Observable<Action> = this.actions$.pipe(
        ofType<PostIncidentMeldungSetzenUiAction>(POST_INCIDENT_MELDUNG_SETZEN_UI),
        withLatestFrom(this.store$.pipe(select(getIncidentDetail)),
            this.store$.pipe(select(getSelectedMeldung))),
        filter(([x, detail, meldung]) => detail !== null && meldung !== null),
        map(([x, detail, meldung]) => {
                const request: IncidentMeldungRequest = {
                    incident_id: detail.incident_id,
                    meldung_id: meldung.meldung_id,
                    text: x.payload,
                };
                return new PostIncidentMeldungAktualisierenAction(request);
            }
        )
    );

   @Effect()
   incidentOK$: Observable<Action> = this.actions$.pipe(
       ofType<PostIncidentOkSetzenUiAction>(POST_INCIDENT_OK_SETZEN_UI),
       withLatestFrom(this.store$.pipe(select(getIncidentDetail))),
       filter(([x, detail]) => detail !== null),
       map(([x, detail]) => {
           const request: IncidentRequest = {
               incident_id: detail.incident_id,
           };
           return new PostIncidentOkErfassenAction(request);
       })
   );

    @Effect()
    incidentNichtOK$: Observable<Action> = this.actions$.pipe(
        ofType<PostIncidentNichtOkSetzenUiAction>(POST_INCIDENT_NICHT_OK_SETZEN_UI),
        withLatestFrom(this.store$.pipe(select(getIncidentDetail))),
        filter(([x, detail]) => detail !== null),
        map(([x, detail]) => {
            const request: IncidentRequest = {
                incident_id: detail.incident_id,
            };
            return new PostIncidentNichtOkErfassenAction(request);
        })
    );

    @Effect()
    incidentUebernehmen$: Observable<Action> = this.actions$.pipe(
        ofType<PostIncidentUebernehmenUiAction>(POST_INCIDENT_UEBERNEHMEN_UI),
        withLatestFrom(this.store$.pipe(select(getIncidentDetail))),
        filter(([x, detail]) => detail !== null),
        map(([x, detail]) => {
            const request: IncidentRequest = {
                incident_id: detail.incident_id,
            };
            return new PostIncidentUebernehmenAction(request);
        })
    );

    @Effect()
    incidentAbgeben$: Observable<Action> = this.actions$.pipe(
        ofType<PostIncidentAbgebenUiAction>(POST_INCIDENT_ABGEBEN_UI),
        withLatestFrom(this.store$.pipe(select(getIncidentDetail))),
        filter(([x, detail]) => detail !== null),
        map(([x, detail]) => {
            const request: IncidentRequest = {
                incident_id: detail.incident_id,
            };
            return new PostIncidentAbgebenAction(request);
        })
    );

    @Effect()
    bildHinzufuegen$: Observable<Action> = this.actions$.pipe(
        ofType<BildIdHinzufuegenAction>(BILD_ID_HINZUFUEGEN),
        withLatestFrom(this.store$.pipe(select(getIncidentDetail))),
        filter(([x, detail]) => x.payload !== null && detail !== null),
        map(([x, detail]) => {
            const request: IncidentBildRequest = {
                incident_id: detail.incident_id,
                upload_id: x.payload,
            };
            return new PostIncidentBildHinzufuegenAction(request);
        })
    );

    @Effect()
    bildEntfernen$: Observable<Action> = this.actions$.pipe(
        ofType<BildIdEntfernenAction>(BILD_ID_ENTFERNEN),
        withLatestFrom(this.store$.pipe(select(getIncidentDetail))),
        filter(([x, detail]) => x.payload !== null && detail !== null),
        map(([x, detail]) => {
            const request: IncidentBildRequest = {
                incident_id: detail.incident_id,
                upload_id: x.payload,
            };
            return new PostIncidentBildEntfernenAction(request);
        })
    );

    constructor(private actions$: Actions,
                private uuid: UuidService,
                private store$: Store<any>) {
    }
}
